import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import About from '../views/About.vue'
import Login from '../views/Login.vue'
import Register from '../views/Register.vue'
import Fighter from '../views/Fighters.vue'
import Fights from '../views/Fights.vue'
import FrontPage from '../views/FrontPage.vue'
import FightPage from '../views/FightPage.vue'
import firebase from 'firebase/compat/app';
import RegisterFrontEnd from '../views/RegisterFrontEnd.vue'
import PastFights from '../views/PastFights.vue'
import UpcomingFights from '../views/UpcomingFights.vue'
import CurrentFights from '../views/CurrentFights.vue'
import 'firebase/compat/auth';
import db from '../firebaseConfig'
import { collection, getDocs, addDoc, updateDoc, doc, deleteDoc, getDoc, query, where, setDoc } from "firebase/firestore";

Vue.use(VueRouter)

const routes = [{
        path: '/home',
        name: 'Home',
        component: Home,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/about',
        name: 'About',
        component: About,
        meta: {
            requiresAuth: true
        }
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        // component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
    },
    {
        path: '/fighters',
        name: 'Fighter',
        component: Fighter,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/fights',
        name: 'Fights',
        component: Fights,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/login',
        name: 'Login',
        component: Login
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            // component: () => import(/* webpackChunkName: "about" */ '../views/Login.vue')
    },
    {
        path: '/register',
        name: 'Register',
        component: Register
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            // component: () => import(/* webpackChunkName: "about" */ '../views/Register.vue')
    },
    {
        path: '/',
        name: 'FrontPage',
        component: FrontPage
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            // component: () => import(/* webpackChunkName: "about" */ '../views/Register.vue')
    },
    {
        path: '/subscribe',
        name: 'RegisterFrontEnd',
        component: RegisterFrontEnd
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            // component: () => import(/* webpackChunkName: "about" */ '../views/Register.vue')
    },
    {
        path: '/past-fights',
        name: 'PastFights',
        component: PastFights
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            // component: () => import(/* webpackChunkName: "about" */ '../views/Register.vue')
    },
    {
        path: '/upcoming-fights',
        name: 'UpcomingFights',
        component: UpcomingFights
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            // component: () => import(/* webpackChunkName: "about" */ '../views/Register.vue')
    },
    {
        path: '/current-fights',
        name: 'CurrentFights',
        component: CurrentFights
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            // component: () => import(/* webpackChunkName: "about" */ '../views/Register.vue')
    },
    {
        path: '/fight/:FightTitle/:uid',
        name: 'FightPage',
        component: FightPage,
        props: true,
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        // component: () => import(/* webpackChunkName: "about" */ '../views/Register.vue')
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 };
    },
    routes
})

// router.beforeEach((to, from, next) => {
//   const currentUser = firebase.auth().currentUser;
//   const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
//   if (requiresAuth && !currentUser && !currentUser.emailVerified) next('login');
//   else if (!requiresAuth && currentUser && currentUser.emailVerified) next('/home');
//   else next();
// });


router.beforeEach(async(to, from, next) => {
    const currentUser = firebase.auth().currentUser;
    let role = ""
    console.log('currentUser', currentUser)
    const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
    if (requiresAuth && !currentUser && !currentUser.emailVerified) next('/');
    else if (requiresAuth && currentUser && currentUser.emailVerified) {

        const q = query(collection(db, "users"), where("Email", "==", currentUser.email));

        const querySnapshot = await getDocs(q);
        querySnapshot.forEach((doc) => {
            // doc.data() is never undefined for query doc snapshots
            let thecurrentuser = doc.data()
            console.log(thecurrentuser.Role)

            role = thecurrentuser.Role
            if (role == "superadmin") {
                console.log('superadmindoc.Role', role);
                // router.push('/home');
                next();
            } else if (role == "subscriber") {
                console.log('subscriberdoc.Role', role);
                next('/');
            }
        });
    } else {
        if (role != "superadmin") {
            console.log('Abrie Test');
            next();
        }
    }


});

export default router